import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'transfix-ui/components/Card'
import { Spinner } from 'transfix-ui/components/Spinner'
import { TableRow } from './TableRow'

export const Table = React.memo(props => {
  const { activeRowId, bidsAreLoading, bidsList, openBookingDialog } = props
  const hasBids = !!bidsList && bidsList.length > 0

  if (bidsAreLoading) return <Spinner position='relative' />

  const count = bidsList && bidsList.length
  return (
    <Card
      collapsedByDefault={!hasBids}
      collapsible
      title={`Carrier Options (${count})`}
      mini
      transparent>
      {!hasBids ? (
        <p>
          <span className='text-secondary'>No options yet.&nbsp;</span>
          <button className='btn-text-link' onClick={openBookingDialog}>
            Add an Option?
          </button>
        </p>
      ) : (
        bidsList.map(bid => {
          const {
            amount,
            carrierApplication,
            carrierApplicationId,
            carrierApplicationName,
            carrierContactName,
            carrierContactPhone,
            carrierContactPhoneExt,
            createdAt,
            createdByName,
            declinedAt,
            id,
            shipmentId,
            source,
            updatedAt,
          } = bid
          const { state: carrierApplicationState } = carrierApplication || {}
          return (
            <TableRow
              key={id}
              updatedAt={updatedAt}
              createdAt={createdAt}
              declinedAt={declinedAt}
              carrierApplicationId={carrierApplicationId}
              carrierApplicationName={carrierApplicationName}
              carrierContactPhone={carrierContactPhone}
              carrierContactPhoneExt={carrierContactPhoneExt}
              carrierApplicationState={carrierApplicationState}
              amount={amount}
              carrierContactName={carrierContactName}
              createdByName={createdByName}
              source={source}
              shipmentId={shipmentId}
              activeRowId={activeRowId}
            />
          )
        })
      )}
    </Card>
  )
})

Table.propTypes = {
  bidsAreLoading: PropTypes.bool,
  bidsList: PropTypes.arrayOf(
    PropTypes.shape({
      updatedAt: PropTypes.string,
      createdAt: PropTypes.string,
      declinedAt: PropTypes.string,
      carrierApplicationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      carrierApplicationName: PropTypes.string,
      carrierContactPhone: PropTypes.string,
      carrierContactPhoneExt: PropTypes.string,
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      carrierContactName: PropTypes.string,
      createdByName: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      source: PropTypes.string,
      shipmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  openBookingDialog: PropTypes.func.isRequired,
  activeRowId: PropTypes.number,
}
Table.defaultProps = {
  bidsAreLoading: true,
  bidsList: [],
  activeRowId: null,
}
